// Usage: t('hero_title', 'home', locale)
import enGlobalRaw from '@/locales/en/en.json';
import esGlobalRaw from '@/locales/es/es.json';
import enHome from '@/locales/en/home.json';
import esHome from '@/locales/es/home.json';
import enAbout from '@/locales/en/about.json';
import esAbout from '@/locales/es/about.json';
import enPortfolio from '@/locales/en/portfolio.json';
import esPortfolio from '@/locales/es/portfolio.json';
import enDesignSystem from '@/locales/en/design-system.json';
import esDesignSystem from '@/locales/es/design-system.json';
import enDevelopmentProces from '@/locales/en/development-proces.json';
import esDevelopmentProces from '@/locales/es/development-proces.json';
const enGlobal = enGlobalRaw as unknown as Record<string, string>;
const esGlobal = esGlobalRaw as unknown as Record<string, string>;
// Add more imports as you add more pages/features

type TranslationValue =
  | string
  | number
  | boolean
  | null
  | undefined
  | TranslationValue[]
  | { [key: string]: TranslationValue };
type TranslationObject = Record<string, TranslationValue>;

const translations: Record<string, Record<string, TranslationObject>> = {
  en: {
    home: enHome,
    global: enGlobal,
    about: enAbout,
    portfolio: enPortfolio,
    'design-system': enDesignSystem,
    'development-proces': enDevelopmentProces,
  },
  es: {
    home: esHome,
    global: esGlobal,
    about: esAbout,
    portfolio: esPortfolio,
    'design-system': esDesignSystem,
    'development-proces': esDevelopmentProces,
  },
};

export function t(
  key: string,
  namespace: string,
  locale: string = 'en'
): string | number | boolean | TranslationValue[] | { [key: string]: TranslationValue } {
  function getNested(obj: Record<string, unknown> | undefined, path: string): unknown {
    return path.split('.').reduce<unknown>((acc, part) => {
      if (typeof acc === 'object' && acc !== null && part in acc) {
        return (acc as Record<string, unknown>)[part];
      }
      return undefined;
    }, obj);
  }

  const value =
    getNested(translations[locale]?.[namespace], key) ??
    getNested(translations['en']?.[namespace], key) ??
    key;

  if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
    return value;
  }
  if (Array.isArray(value)) {
    return value;
  }
  if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
    // Check if value is a plain object
    return value as { [key: string]: TranslationValue };
  }
  return key;
}
